<template>
  <div class="page-wrap">
    <div
      :class="['prev', currentPage === 1 || totalPage <= 1 ? 'prev-disabled' : '']"
      tabindex="-1"
      @click="handlePage('prev')"
    >
      <i class="bi bi-arrow-left arrow"></i>
    </div>
    <div class="page">
      <div
        :class="['dot', currentPage === num && totalPage > 1 ? 'dot-action' : '']"
        v-for="num in totalPage || 1"
        :key="num"
      ></div>
    </div>
    <div
      :class="['next', currentPage === totalPage || totalPage <= 1 ? 'next-disabled' : '']"
      tabindex="-1"
      @click="handlePage('next')"
    >
      <i class="bi bi-arrow-right arrow"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cus-page',
  props: {
    totalPage: { type: Number, default: 1 },
    currentPage: { type: Number, default: 1 },
    handleClick: { type: undefined },
  },
  data() {
    return {};
  },
  methods: {
    handlePage(action) {
      switch (action) {
        case 'next':
          if (this.handleClick) this.handleClick(this.currentPage + 1);
          else this.$emit('update:currentPage', this.currentPage + 1);
          break;
        case 'prev':
          if (this.handleClick) this.handleClick(this.currentPage - 1);
          else this.$emit('update:currentPage', this.currentPage - 1);
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrap {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 50px auto 50px;
  align-items: center;
  font-size: 3rem;
}
.page {
  @include flex-center-center;
  flex-wrap: wrap;
}
.next,
.prev {
  @include flex-center-center;
  color: $color-blue;
  cursor: pointer;
  transition: 0.2s;
  // &:focus {
  //   color: $color-lightBlue;
  // }
  &-disabled {
    pointer-events: none;
    opacity: 0.4;
  }
}
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: $color-blue;
  opacity: 0.5;
  margin: 3px;
  transition: 0.2s;
  &-action {
    opacity: 1;
  }
}

.arrow {
  -webkit-text-stroke: 0.5px $color-blue;
}
</style>
